import i18n from "@shared/i18n/i18n";
import { ErrorBoundary, PasswordVerificationProvider, PolarisProvider } from "@shared/ui";
import store from "@app/store/store";
import { Analytics } from "@vercel/analytics/react";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { Provider as ReduxProvider } from "react-redux";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@medentic/polaris-react/styles.css";
import "@fontsource/inter";
import "@fontsource/inter/400.css";
import "@fontsource/inter/700.css";
import { initSentry } from "@shared/lib";
import type { ReactNode } from "react";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      retry: false,
    },
  },
});

initSentry();

const base = import.meta.env.BASE_URL || "/";

type AppProvidersProps = {
  children: ReactNode;
};

export default function AppProviders({ children }: AppProvidersProps) {
  return (
    <ErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <ReduxProvider store={store}>
          <PolarisProvider>
            <QueryClientProvider client={queryClient}>
              <BrowserRouter basename={base}>
                <PasswordVerificationProvider>
                  {children}
                  <Analytics />
                </PasswordVerificationProvider>
              </BrowserRouter>
            </QueryClientProvider>
          </PolarisProvider>
        </ReduxProvider>
      </I18nextProvider>
    </ErrorBoundary>
  );
}
